<template>
  <div class="pa-connection-create-pod">
    <div class="pa-create-pod">
      <div class="pa-title">新しいポットの取り寄せ</div>
      <div class="pa-description">
        <p>「きなこきびだんご」を【一つ】使用して新しいマイポットを取り寄せます。</p>
        <p>マイポットの名前を決めてください。</p>
      </div>
      <form class="pa-form">
        <input type="text" v-model="inputName" placeholder="マイポットの名前" />
        <button
         class="button pa-submit"
         :class="additionalSubmitClass"
         :disabled="isDisabledSubmitButton"
         @click.prevent="handleSubmitButton"
        >ポットを取り寄せる</button>
      </form>
      <button
       class="pa-cancel"
       :disabled="isDisabledCancelButton"
       @click.prevent="handleCancelButton"
      >キャンセル</button>
    </div>
  </div>
</template>

<script>
export default {
  props : {
    isLoading : {
      default : false,
    },
  },
  
  data(){
    return {
      inputName               : null,

      additionalSubmitClass   : {
        'is-loading'  : false,
      },

      isDisabledSubmitButton  : false,
      isDisabledCancelButton  : false
    };
  },

  watch : {
    isLoading(value){
      if(value === true){
        this.additionalSubmitClass['is-loading'] = true;
        this.isDisabledSubmitButton = true;
        this.isDisabledCancelButton = true;
      }else{
        this.additionalSubmitClass['is-loading'] = false;
        this.isDisabledSubmitButton = false
        this.isDisabledCancelButton = false;
      }
    },
  },

  methods : {
    handleSubmitButton(){
      if(this.inputName === '' || this.inputName === null) return;
      
      this.$emit('submitButton', this.inputName);
    },

    handleCancelButton(){
      this.$emit('clickCancel');
    }
  }
}
</script>

<style lang="scss">
.pa-connection-create-pod{
  width:100%;
  height:100%;
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  
  .pa-create-pod{
    width:98%;
    margin:0 auto;
    margin-top:-1rem;
    border:3px solid #B57D3C;
    background-color: #C8A984;
    color:#7C5E49;
    border-radius: 6px;

    .pa-title{
      border-bottom:2px solid #AE906B;
      text-align: center;
      font-size: 1.4rem;
      line-height: 2.4rem;
      width:95%;
      margin:0 auto;
    }
    
    .pa-description{
      width:95%;
      margin:.2rem auto 0;
      font-size:.8rem;
      text-align: center;
    }

    .pa-form{
      input{
        border-radius: 20px;
        border:2px solid #89620C;
        background-color:#DDCEB3;
        color:#6C4D37;
        font-weight: bold;
        width:90%;
        margin:.5rem auto .6rem;
        display: block;
        padding:5px 10px;
        font-size:1rem;
        
        &:focus{
          outline:none;
        }

        &::placeholder{
          color:#B39E8F;
          font-weight: bold;
        }
      }
      
      .pa-submit{
        border:2px solid #723E14;
        background: #874D26;
        color: #E8DFD9;
        font-size:1rem;
        line-height: 1;
        padding:3px 1rem;
        border-radius: 6px;
        display: block;
        margin:0 auto;
      }
    }

    .pa-cancel{
      border:none;
      background-color:inherit;
      font-weight: bold;
      color:#7C5E49;
      display: block;
      margin: 0 .5rem .2rem auto;
      padding:0;
    }
  }
}
</style>